import { makeStyles, Link as MuiLink, TextField } from '@material-ui/core'
import ButtonSp from '../../ui/ButtonSp'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(1),
    '& p': {
      ...theme.homeStyle.bodyText,
      margin: `${theme.spacing(1)}px 0`,
      textAlign: 'center',
    },
    '& h1': {
      ...theme.headerFont,
      color: theme.palette.primary.main,
      margin: `${theme.spacing(0)}px 0`,
    },
  },
  button: {
    height: 50,
  },
  field: {
    margin: `${theme.spacing(1)}px 0`,
  },
}))

const TrackingInfoForm = ({
  trackingCode,
  setTrackingCode,
  onSubmit,
  notFoundStatus,
}) => {
  const classes = useStyles()

  const setExample = () => {
    setTrackingCode('SP000040178')
  }

  return (
    <div className={classes.root}>
      <h1>ติดตามพัสดุ</h1>
      <p>
        ผู้ใช้งานกรอกรหัส Tracking Code
        <br />
        ลงในช่องว่างด้านล่างนี้
      </p>
      <p>
        ตัวอย่าง : <MuiLink onClick={setExample}>SP000040178</MuiLink>
      </p>
      <TextField
        label="รหัสพัสดุ"
        variant="outlined"
        fullWidth
        value={trackingCode}
        onChange={(e) => {
          setTrackingCode(e.target.value)
        }}
        className={classes.field}
        helperText={
          notFoundStatus && (
            <span style={{ color: 'red' }}>ไม่พบรายการที่คุณค้นหา</span>
          )
        }
      />
      <ButtonSp className={classes.button} onClick={onSubmit}>
        ตรวจสอบสถานะสินค้า
      </ButtonSp>
    </div>
  )
}

export default TrackingInfoForm
